import { ChakraV3, dataAttr } from '@piccolohealth/ui';
import React from 'react';
import { FaChartBar, FaTable } from 'react-icons/fa';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const ParticipantDataTabButtons = (props: Props) => {
  const { value, onChange } = props;

  const buttonSx = {
    bg: 'gray.100',
    color: 'gray.400',
    rounded: 'md',
    fontSize: 'sm',
    fontWeight: 'semibold',
    py: 1,
    px: 4,
    h: 'auto',
    lineHeight: 'inherit',
    _selected: {
      bg: 'white',
      color: 'gray.600',
    },
  };

  return (
    <ChakraV3.Tabs.List w='fit-content' gap={0} bg='gray.100' rounded='lg'>
      <ChakraV3.Tabs.Trigger value='widgets' p={1}>
        <ChakraV3.Button
          size='sm'
          css={buttonSx}
          onClick={() => onChange('widgets')}
          {...{ 'data-selected': dataAttr(value === 'widgets') }}
        >
          <FaChartBar />
          Widgets view
        </ChakraV3.Button>
      </ChakraV3.Tabs.Trigger>
      <ChakraV3.Tabs.Trigger value='tables' p={1}>
        <ChakraV3.Button
          size='sm'
          css={buttonSx}
          onClick={() => onChange('tables')}
          {...{ 'data-selected': dataAttr(value === 'tables') }}
        >
          <FaTable />
          Table view
        </ChakraV3.Button>
      </ChakraV3.Tabs.Trigger>
    </ChakraV3.Tabs.List>
  );
};
